import StateStoreAdapter from './types'

export default {
  objectives: {},
  tracking: {}
} as StateStoreAdapter
